/**
 * Générateur — Automatisme : entretenir les tables de multiplications.
 * Attendu ID : 1058 | Niveau : 5ème | Domaine : Puissances
 * Rubrique : AUTOMATISME (programme 2025, cycle 4 page 8, ligne 585, rangé
 * sous Puissances : les tables sont le socle des carrés, objectif 927, et
 * du cube de 10 qui porte les unités d'aires et de volume, 1059).
 *
 * ── WRAPPER (décision prof 2026-09-09) ─────────────────────────────────────
 * C'est mot pour mot l'automatisme 1047 (Nombres rationnels, ligne 547 :
 * « Entretenir la connaissance et l'utilisation des tables de
 * multiplication »). Ce gen DÉLÈGUE intégralement à gen_1047, déjà criblé,
 * revu et doté de son coup de pouce : zéro duplication, une seule
 * maintenance. Le payload est re-badgé (attendu 1058) ; les cartes, formats,
 * generator_keys, invariants et distracteurs sont ceux de 1047. Côté coups
 * de pouce et solveurs, l'entrée 1058 réutilise l'entrée 1047 : voir
 * coupsDePouce/index.js et tests/solvers/index.js. Épreuve de Musk : pas de
 * carte « carré » ici, les carrés des entiers de 0 à 12 sont l'objectif 927.
 */
import { generate as genererTables, CATEGORIES as CAT_TABLES } from '../nombres-rationnels/gen_1047';

const ATTENDU_ID = 1058;

export const CATEGORIES = CAT_TABLES;

export const generate = (typeExercice) => {
    const payload = genererTables(typeExercice);
    payload.attendu = ATTENDU_ID;
    return payload;
};
